import DataProvider from '@app/model/_common/DataProvider';
import ReviewBookInfo from '@app/model/review/ReviewBookInfo';
import ReviewCustomerInfo from '@app/model/review/ReviewCustomerInfo';
import { ReviewText } from '@app/model/review/ReviewText';
import ReviewTextType from '@app/model/review/ReviewTextType';
import ReviewTextTopic from '@app/model/review/ReviewTextTopic';

class Review {
	id: number;
	hotelId: number;
	provider: DataProvider;
	providerId: number;
	creationDate: string;
	roomName: string;
	score: number;
	reviewDate: string;
	bookInfo: ReviewBookInfo;
	customerInfo: ReviewCustomerInfo;
	texts: ReviewText[];

	constructor(data: Partial<Review> = {}) {
		Object.assign(this, data);
		if(data.texts) {
			this.texts = data.texts.map(t => new ReviewText(t));
		}
	}

	public getTitle() {
		return this.texts?.find(t => t.type === ReviewTextType.TITLE)?.text ?? '';
	}

	public getTranslatedTitle() {
		const reviewText = this.texts?.find(t => t.type === ReviewTextType.TITLE);
		return !reviewText ? '' : reviewText.translation || reviewText.text;
	}

	public isNotTranslated() {
		return this.texts?.some(t => !t.translation && t.language !== 'en');
	}

	public getTopics(): ReviewTextTopic[] {
		const topics: ReviewTextTopic[] = [];
		this.texts?.forEach(t => t.getTopics().forEach(t=>topics.push(t)));
		return topics;
	}
}

export default Review;